import getEnv from '../../services/util/getEnv';

const constants = {
    LOGGING_SESSION_TIMEOUT: getEnv("REACT_APP_LOGGING_SESSION_TIMEOUT"),
    LOGGING_SESSION_TIMEOUT_UNIT: getEnv("REACT_APP_LOGGING_SESSION_TIMEOUT_UNIT")
};

export default constants;
